import React, { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { LinkButton } from 'src/components';
import { ROUTES } from 'src/constants/routes.const';
import * as S from 'src/apps/Buddies/BuddiesPromotionCard/styles';
import BuddiesImage from '../buddies.png';

const msgs = defineMessages({
  title: {
    id: 'ai_buddies_home_card_title',
    defaultMessage: 'Practice with AI Buddies',
  },
  description: {
    id: 'ai_buddies_home_card_description',
    defaultMessage:
      'Use the words you learn to build sentences, practice grammar, role play conversations and more.',
  },
  cta: {
    id: 'ai_buddies_home_card_cta',
    defaultMessage: 'Try AI Buddies',
  },
  close: { id: 'close' },
});

export const BuddiesPromotionCard: FC<{ onClose: () => void }> = ({ onClose }) => {
  const intl = useIntl();

  return (
    <S.Card data-testid="buddies-promotion-card">
      <S.CloseButton
        onClick={onClose}
        title={intl.formatMessage(msgs.close)}
        aria-label={intl.formatMessage(msgs.close)}
      >
        <S.CloseIcon name="close" />
      </S.CloseButton>
      <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
      <S.Description>{intl.formatMessage(msgs.description)}</S.Description>
      <S.BottomWrapper>
        <S.Image src={BuddiesImage} />
        <LinkButton buttonType="primary" buttonSize="small" href={ROUTES.ai.buddies}>
          {intl.formatMessage(msgs.cta)}
        </LinkButton>
      </S.BottomWrapper>
    </S.Card>
  );
};
